import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PricingModalService {
  private openPricingModalSubject = new BehaviorSubject<boolean>(false);
  public openPricingModal$ = this.openPricingModalSubject.asObservable();

  openPricingModal() {
    this.openPricingModalSubject.next(true);
  }

  closePricingModal() {
    this.openPricingModalSubject.next(false);
  }

  // Method to handle direct opening from route
  openPricingModalDirectly() {
    // Small delay to ensure the component is fully loaded
    setTimeout(() => {
      this.openPricingModalSubject.next(true);
    }, 100);
  }
} 